import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconKeyboard"><Path fillRule="evenodd" clipRule="evenodd" d="M22.5 19.25H1.5V4.75H22.5V19.25ZM5.5 13.1504V14.8496H7.35742V13.1504H5.5ZM9.21387 13.1504V14.8496H14.7861V13.1504H9.21387ZM16.6426 13.1504V14.8496H18.5V13.1504H16.6426ZM5.5 9.15039V10.8496H7.35742V9.15039H5.5ZM9.21387 9.15039V10.8496H11.0713V9.15039H9.21387ZM12.9287 9.15039V10.8496H14.7861V9.15039H12.9287ZM16.6426 9.15039V10.8496H18.5V9.15039H16.6426Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyboard;
